export const name = 'tools'

export const REFRESH_BADWORDSCORE = `${name}/REFRESH_BADWORDSCORE`
export const REFRESH_BADWORDSCORE_ERROR = `${name}/REFRESH_BADWORDSCORE_ERROR`
export const REFRESH_BADWORDSCORE_SUCCESS = `${name}/REFRESH_BADWORDSCORE_SUCCESS`

export const REROLL_EXPERIMENTS = `${name}/REROLL_EXPERIMENTS`
export const REROLL_EXPERIMENTS_ERROR = `${name}/REROLL_EXPERIMENTS_ERROR`
export const REROLL_EXPERIMENTS_SUCCESS = `${name}/REROLL_EXPERIMENTS_SUCCESS`
